<template lang="">
    <div class="myb">
        
        <Button v-if="!confirm" @click="start()">{{ $t(text)}}</Button>
        <div v-if="confirm" class="inline-block">
            <div class="inline-block">{{ $t('confirm.generic')}}</div>
            <Button class="ml-3" @click="yes()">{{ $t('confirm.yes')}}</Button>
            <Button class="ml-3" @click="no()">{{ $t('confirm.no')}}</Button>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            confirm: false,
           
        };
    },
    mounted() {
        this.confirm = false;
    },
    props: ["text"],
    methods: {
        no() {
            this.confirm = false;
        },
        yes() {
            this.$emit('yes');
            this.confirm = false;
            
        },
        start() {
            this.confirm = true;
        }
    }
}
</script>

<style lang="scss" scoped>
.myb .p-button {
    margin: 0;
    display: inline-flex;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none;
    align-items: center;
    vertical-align: bottom;
    text-align: center;
    overflow: hidden;
    position: relative;
}</style>